import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage--localfilesystem" id="module-storage--localfilesystem"></a>
    <h1 {...{
      "id": "requireuxpstoragelocalfilesystem"
    }}>{`require('uxp').storage.localFileSystem`}</h1>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      